import { Typography, Box } from "@mui/material";

export const Title = ({ title }: { title: string }) => {
  return (
    <Box display="flex">
      <Typography component="p">{title}</Typography>
    </Box>
  );
};
